import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from '@angular/core'
import { ScopeElementsConfig, UpdateFeeItemPayload, UpdateRolePayload, UpdateTpcPayload } from '../models'

import { CdnConfig } from '@app/core/model/cdn-config.model'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { MenuOptions } from '@app/core/model/definitions/menu-options.interface'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ScopeElementsService } from '../services/scope-elements.service'
import { ScopeSection } from '@app/features/scope-overview/model/scope-section'
import { ScopeTabService } from '@app/features/scope-overview/service/scope-tab.service'
import { ThirdPartyCost } from '@app/core/model/third-party-cost.model'
import { trackById } from '@app/shared/utils/utils'

@Component({ selector: 'scope-deliverables', templateUrl: './deliverables.component.html' })
export class DeliverablesComponent implements OnChanges {
  @Input() level = 2
  @Input() config: ScopeElementsConfig
  @Input() cdnConfig?: CdnConfig
  @Input() section?: ScopeSection
  @Input() deliverables: Deliverable[] = []

  @Input() deliverableMenuOptions: MenuOptions[]
  @Input() componentMenuOptions: MenuOptions[]
  @Input() feeMenuOptions: MenuOptions[]

  @Output() onExpandDeliverable = new EventEmitter<{ scopeId: number; deliverableId: number }>()
  @Output() onUpdateDeliverable = new EventEmitter<Deliverable>()
  @Output() onAcceptDeliverable = new EventEmitter<Deliverable>()
  @Output() onRejectDeliverable = new EventEmitter<Deliverable>()

  @Output() onUpdateComponent = new EventEmitter<ScopeComponent>()
  @Output() onOverrideComponentQuantity = new EventEmitter<ScopeComponent>()
  @Output() onOverrideRateCardRoleHours = new EventEmitter<UpdateRolePayload>()
  @Output() onUpdateRole = new EventEmitter<UpdateRolePayload>()
  @Output() onMoveComponent = new EventEmitter<{ component: ScopeComponent; deliverable: Deliverable }>()
  @Output() onMoveComponentOutsideDeliverable = new EventEmitter<ScopeComponent>()
  @Output() onUpdateFeeItem = new EventEmitter<UpdateFeeItemPayload>()
  @Output() onUpdateDeliverableTpc = new EventEmitter<UpdateTpcPayload>()
  @Output() onUpdateComponentTpc = new EventEmitter<UpdateTpcPayload>()
  @Output() onUpdateDeliverableSectionTpc = new EventEmitter<UpdateTpcPayload>()
  @Output() onReorderDeliverableTpcs = new EventEmitter<{
    deliverable: Deliverable
    thirdPartyCosts: ThirdPartyCost[]
  }>()
  @Output() onReorderComponentTpcs = new EventEmitter<any>()
  @Output() onReorderDeliverableSectionTpcs = new EventEmitter<any>()

  constructor(
    protected scopeTabService: ScopeTabService,
    protected scopeElementsService: ScopeElementsService
  ) {
    scopeElementsService.setFeeColumns()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.scopeVersion && this.config.scopeVersion && !this.scopeElementsService.userColumns)
      this.scopeElementsService.setUserColumns(this.config.scopeVersion)
  }

  expandDeliverable(scopeId: number, deliverableId: number) {
    this.onExpandDeliverable.emit({ scopeId, deliverableId })
  }

  protected readonly trackById = trackById
}
